import sanitizeHtml from 'sanitize-html';
import moment from 'moment'
import stringTest from '../components/stringTest';
import SchedulerWizard from '../features/scheduler/SchedulerWizard';

export default class Scheduler {

    constructor() {
        this.modal
        this.modal = $('#scheduleModal')
        this.formid = '#schedule_add_form'
        this.previousScheduleStartDate = ''
        this.previousScheduleEndDate = ''
        this.token=$('meta[name="csrf-token"]').attr('content');
        this.oldTimePicked = '';    //card id 756
        // card 639
        this.changeProfileForm = $('#changeProfileInfoForm')
        this.changeProfileForm.on('submit', e => setTimeout(() => {
            this.listSchedules()
        }, 1000))
        // end card 639
        this.userDiffTime = 30;
        this.strTest = new stringTest();
        this.modsCanAccessKino = $('#mods-can-access-kino');
        this.membersCanAccessKino = $('#members-can-access-kino');

        this.caretDownSvg = `<svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24" enable-background="new 0 0 24 24" width="18px" height="20px"><path style="text-indent:0;text-align:start;line-height:normal;text-transform:none;block-progression:tb;-inkscape-font-specification:Bitstream Vera Sans" d="M 11 5 L 11 11 L 5 11 L 5 13 L 11 13 L 11 19 L 13 19 L 13 13 L 19 13 L 19 11 L 13 11 L 13 5 L 11 5 z" overflow="visible" enable-background="accumulate" font-family="Bitstream Vera Sans"/></svg>`;
        this.caretUpSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18px" height="20px"><path d="M 5 11 L 5 13 L 19 13 L 19 11 L 5 11 z"/></svg>`;

        this.sanitizeNoOptions = {
            allowedTags: ['div'],
            allowedAttributes: {
                span: [],
                img: [],
                div: []
            },
            allowedSchemesByTag: {
                img: []
            }
        }        
        $("#scheduleKinoNew").on('click',()=>{
            let scheduleSetup=new SchedulerWizard();
            scheduleSetup.showSetup();
            scheduleSetup.onClose=()=>{
                scheduleSetup=undefined;
            };
            scheduleSetup.onSuccess=this.onScheduleSuccess.bind(this);
        });
        this.modal.find("#submit_schedule").on('click', e => {
            $('#schedule_modal_scheduled_table_btn').addClass('disabled');
            setTimeout(() => {
                $('#schedule_modal_scheduled_table_btn').removeClass('disabled');
            }, 2000);
            
            $(e.currentTarget).parent().find('.loading-scr').removeClass('d-none')
            $(e.currentTarget).prop('disabled', true)
            setTimeout( async () => {
                await this.addSchedule( async res => {
                    // editing add to gmail button with javascript to get the right data
                    console.log("The result needed: ", res);
                    
                    if(res){
                        this.selectedMembersEmails=[];
                        this.memberParticipantsContainer.find('.user-container').remove();
                        $('#email-schedule-btn').data('id', res.id)
                        $('#email-schedule-btn').data('title', res.title)
                        await axios.get(`/connect/outlook-google/calendar/${res.id}`).then( async result => {
                            $('#add_to_gmail_group a').attr('href', result.data.google)
                            $('#add_to_gmail_group a').attr('target', '_blank')

                            $('#add_to_outlook_group a').attr('href', result.data.outlook)
                            $('#add_to_outlook_group a').attr('target', '_blank')

                            // loading schedule information
                            // $('#schedule-info-modal-title').text(res.title)
                            $('#schedule-info-body').html('')

                            $('#schedule-info-body').append(`
                                <div class="item">
                                    <div class="title">
                                        <span>Title</span>
                                    </div>
                                    <div class="content">
                                        <span>${res.title}</span>
                                    </div>
                                </div>
                            `);
                            // how next event was before ${res.schedule_date}
                            // if(res.recurring && (res.schedule_date != moment.utc(res.schedule_creation).format('dddd, MMMM DD'))) {
                               
                            $('#schedule-info-body').append(`
                                <div class="item mt-1">
                                    <div class="title">
                                        <span>Created on</span>
                                    </div>
                                    <div class="content">
                                        <span>${moment.utc(res.schedule_creation).format('dddd, MMMM Do, YYYY')}</span>
                                    </div>
                                </div>
                            `)
                            $('#schedule-info-body').append(`
                                <div class="item mt-1">
                                    <div class="title">
                                        <span>Event date</span>
                                    </div>
                                    <div class="content">
                                        <span>${moment.utc(res.next_event_date).format('dddd, MMMM Do, YYYY')} from ${schedule_start_time} to ${schedule_end_time}</span>
                                    </div>
                                </div>
                            `)
                            // } else {
                            //     $('#schedule-info-body').append(`
                            //         <div class="item mt-1">
                            //             <div class="title">
                            //                 <span>Date created</span>
                            //             </div>
                            //             <div class="content">
                            //                 <span>${res.schedule_date}</span>
                            //             </div>
                            //         </div>
                            //     `)
                            // }

                            let schedule_time = res.schedule_time.split(' - ')
                            let schedule_start_time = schedule_time[0]
                            let schedule_end_time = schedule_time[1]

                            // $('#schedule-info-body').append(`
                            //     <div class="item mt-1">
                            //         <div class="title">
                            //             <span>Start Time</span>
                            //         </div>
                            //         <div class="content">
                            //         <span>${schedule_start_time}</span>
                            //         </div>
                            //     </div>
                            // `)
                            // $('#schedule-info-body').append(`
                            //     <div class="item mt-1">
                            //         <div class="title">
                            //             <span>End Time</span>
                            //         </div>
                            //         <div class="content">
                            //         <span>${schedule_end_time}</span>
                            //         </div>
                            //     </div>
                            // `)
                            $('#schedule-info-body').append(`
                                <div class="item mt-1">
                                    <div class="title">
                                        <span>Scheduled Kino Link</span>
                                    </div>
                                    <div class="content">
                                    <a href="${res.location}">${res.location}</a>
                                    </div>
                                </div>
                            `)
                            if(res.recurring) {
                                $('#schedule-info-body').append(`
                                    <div class="item mt-1">
                                        <div class="title">
                                            <span>Recurring</span>
                                        </div>
                                        <div class="content">
                                        <span>${ res.recurring?.split('').map( (e, i) => i === 0 ? e.toUpperCase() : e ).join('')}</span>
                                        </div>
                                    </div>
                                `)
                            }
                            // EXPAND MODERATORS
                            if(res.moderators && res.moderators.length) {
                                $('#schedule-info-body').append(`
                                    <div class="item mt-1">
                                        <div class="title cursor-pointer" id="scheduler-info-moderators-button">
                                            ${this.this.caretDownSvg}
                                            <span>Moderators </span>
                                        </div>
                                        <div class="content scheduler-info-moderators-hidden">
                                        <span>${ res.moderators.join(', ')}</span>
                                        </div>
                                    </div>
                                `)
                            }
                            $('#scheduler-info-moderators-button').on('click', function(){
                                if($('.scheduler-info-moderators-hidden').hasClass('expanded')){
                                    $('.scheduler-info-moderators-hidden').removeClass('expanded')
                                    $(this).html(`${this.caretDownSvg} Moderators`)
                                }else{
                                    $('.scheduler-info-moderators-hidden').addClass('expanded')
                                    $(this).html(`Moderators ${this.caretUpSvg}`)
                                }
                            });

                            // EXPAND MEMBERS
                            if(res.members && res.members.length) {
                                $('#schedule-info-body').append(`
                                    <div class="item mt-1">
                                        <div class="title cursor-pointer" id="scheduler-info-members-button">
                                            ${this.caretDownSvg}
                                            <span>Members</span>
                                        </div>
                                        <div class="content scheduler-info-members-hidden">
                                        <span>${ res.members.join(', ')}</span>
                                        </div>
                                    </div>
                                `)
                            }
                            $('#scheduler-info-members-button').on('click', function(){
                                if($('.scheduler-info-members-hidden').hasClass('expanded')){
                                    $('.scheduler-info-members-hidden').removeClass('expanded')
                                    $(this).html(`${this.caretDownSvg} Members`)
                                }else{
                                    $('.scheduler-info-members-hidden').addClass('expanded')
                                    $(this).html(`${this.caretUpSvg} Members`)
                                }
                            });


                            let readMore = res.summary.length >= 200 ? true : false;
                            $('#schedule-info-body').append(`
                                <div class="item mt-1">
                                    <div class="title">
                                        <span>Summary</span>
                                    </div>
                                    <div class="content">
                                    <span class="m-0" id="summary-content">${(res.summary.trim().length) ? (readMore ? res.summary.substring(0, 200) + "..." : res.summary) : 'No description added'}</span>
                                    <span class="show-more-summary">Show more</span>
                                    </div>
                                </div>
                            `)
                            // SHOW MORE ON SUMMARY
                            if (res.summary.length >= 200) {
                                $('.show-more-summary').show();
                            }
                            $('.show-more-summary').on('click', function() {
                                if(readMore){
                                    readMore = false;
                                    $('#summary-content').text(res.summary);
                                } else {
                                    readMore = true;
                                    $('#summary-content').text(`${res.summary.substring(0, 200)}...`);
                                }
                                $(this).text() === 'Show more' ? $(this).text('Show less') : $(this).text('Show more');
                            });

                            $('#scheduleModal').modal('hide')
                            setTimeout(() => {
                                $('#schedule-info-modal').modal()
                            }, 500);

                            setTimeout(() => {
                                $(e.currentTarget).prop('disabled', false)
                                $(e.currentTarget).parent().find('.loading-scr').addClass('d-none')
                            }, 1500);
                        })
                    } else {
                        $(e.currentTarget).prop('disabled', false)
                        $(e.currentTarget).parent().find('.loading-scr').addClass('d-none')
                    }

                });
            }, 500);
        });

        /* ==== card-789 === */
        // $('#cancel-schedule-modal').modal().find('.kino-btn-secondary').addClass('w-100px');
        $('#cancel-schedule-btn').on('click', e => this.cancelSchedule())
        /* === enc card-789 ==== */
        $("#schedule_modal_scheduled_table_btn").on('click',()=>{
            let scheduleSetup=new SchedulerWizard();
            scheduleSetup.showSetup();
            scheduleSetup.onClose=()=>{
                scheduleSetup=undefined;
            };
            scheduleSetup.onSuccess=this.onScheduleSuccess.bind(this);
        })
        //set selected current time with 30m
        let current_time_local = moment();
        let selection_index_after = 0
        let selection_index_after_max = 2
        let current_selection_time = moment();

        Array.from($('#schedule_start_time').children()).forEach(el => {
            current_selection_time = moment(el.value, 'hh:mm A')
            if(!current_selection_time.isBefore(current_time_local)) {
                selection_index_after++;
            }
            if(selection_index_after_max == selection_index_after) {
                $('#schedule_start_time').val(el.value);
                $('#schedule_start_time_input').val(el.value);  //card id 756
            }
        })

        // selecting end date on load
        // console.log(current_selection_time.format('YYYY-MM-DD hh:mm A'))
        $('#schedule_end_date').val(current_selection_time.format('YYYY-MM-DD'))
        $('#schedule_end_time').val(current_selection_time.format('hh:mm A'))


        // send email from schedule modal
        $('#email-schedule-btn').on('click', function(e) {
            $('#email-schedule-btn').parent().find('.loading-scr').removeClass('d-none')
            $('#email-schedule-btn').prop('disabled', true)

            if($('#email-schedule-btn').data('title') && $('#email-schedule-btn').data('id')) {
                axios.get(`/schedule/${$('#email-schedule-btn').data('id')}/invite/email/`).then(res => {
                    download(res.data, $('#email-schedule-btn').data('title') + ".ics", 'text/calendar')

                    $('#email-schedule-btn').data('downloads', $('#email-schedule-btn').data('downloads')+1)
                    setTimeout(() => {
                        $('#email-schedule-btn').parent().find('.loading-scr').addClass('d-none')
                        if($('#email-schedule-btn').data('downloads')<2) {
                            $('#email-schedule-btn').prop('disabled', false)
                        }
                    }, 2000);
                }).catch(err => {
                    console.log(err)
                })
            }
        })

         // No Timezone Modal
        $('#update-profile-modal').on('click', function () {
            $('#errorScheduleModal').modal('hide');
            let timezoneSelected = $('#timezone_field_modal').find(":selected").val();
            $('#timezone_field').val(timezoneSelected).change();
            $('#timezone_field').submit();
        });

        // reset doownload schedule button counter
        $('#schedule-info-modal').on('hidden.bs.modal', e => {
            $('#email-schedule-btn').data('downloads', 0)
            $('#email-schedule-btn').prop('disabled', false)
        })

        //send to gmail
        $('#gmail-schedule-btn').on('click', (e) => {
            $(e.currentTarget).parent().find('.loading-scr').removeClass('d-none')
            $(e.currentTarget).prop('disabled', true)

            //gets the latest created calendar of the authenticated user and adds it to their gmail account
            axios.get(`/connect/google/calendar/`).then(res => {
                $(e.currentTarget).parent().find('.loading-scr').addClass('d-none')
                $(e.currentTarget).prop('disabled', false)
                $('#add_to_gmail_group').addClass('d-none').removeClass('d-flex')
                $('#add_to_gmail_group').parent().append(`
                    <a href="${res.data.url}" target="_blank" type="button" class="btn btn-primary d-flex align-items-center">
                        <i class="fas fa-calendar-plus mr-2"></i>
                        Add to Calendar
                    </a>
                `)

            }).catch(err => {
                console.log(err)
            })
            // $('#gmail-schedule-btn').attr('href', '')

            // console.log("click")
        })

        this.modal.find('#whatsapp-schedule-btn').on('click', function(e) {
            $(e.currentTarget).parent().find('.loading-scr').removeClass('d-none')
            $(e.currentTarget).prop('disabled', true)
        })

        // Schedule changed events


        let now=new Date();

        let startTime=moment().add(15, 'minutes').format('hh:mm A');    //card id 756
        let startDate=moment().add(15, 'minutes').toDate();             //card id 756
        $("#schedule_start_time").val(startTime);           //card id 756         
        $("#schedule_start_time_input").val(startTime);     //card id 756  
        var tzName = moment.tz.guess();
        $("#scheduler_timezone").val(tzName);
        $('#schedule_start_date').val(moment().format("YYYY-MM-DD"))
        flatpickr("#schedule_start_date_container", {
            minDate: "today",
            // static: true,
            wrap: true,
            // dateFormat: "Y-m-d"
        });
        flatpickr("#schedule_end_date_container", {
            minDate: "today",
            // static: true,
            wrap: true,
            // dateFormat: "Y-m-d"
        });

        // card id 756 begin
        $('#schedule_start_time_input').on('blur', (e) => {
            let timeValue = $('#schedule_start_time_input');
            this.checkIfTimeIsCorrect(timeValue);
            this.updateInputsDate();
            this.populateInputOneHourPrior('moderator');
            this.populateInputOneHourPrior('member');
            this.populateInputOneHourPrior('guest');
            $('#submit_schedule').attr('disabled', false)
        }).on('focus', (e) =>{
            // console.log(e.currentTarget.value)
            this.oldTimePicked = e.currentTarget.value
        });
        $('#schedule_end_time_input').on('blur', (e) => {
            let timeValue = $('#schedule_end_time_input');
            this.checkIfTimeIsCorrect(timeValue);
            $('#submit_schedule').attr('disabled', false)
            this.changeSchedulerDuration();
        });
        
        this.updateInputsDate();    // card id 689
        
        $('#scheduleModal').on('shown.bs.modal', () => {
            this.updateInputsDate();
            if($('#recurring_daily').is(':checked') || $('#recurring_weekly').is(':checked') || $('#recurring_monthly').is(':checked')){
                $('#keep-chat-checkbox').prop('disabled', false)
            }
            if($("#currentScheduleID").val()<=0){
                this.populateInputOneHourPrior('moderator');
                this.populateInputOneHourPrior('member');
                this.populateInputOneHourPrior('guest');
            }
        });
        // card id 756 end

        $('#scheduleModal').on('hidden.bs.modal', () => {
            $("#currentScheduleID").val(0);
            $('#sch-title').val('');
            // $('#participants').html('');
            $('#sch-summary').val('');
            this.modal.find("#submit_schedule").html("Schedule");
            $('#scheduleModal').attr('disabled', false)
            $('#submit_schedule').attr('disabled', false)
            $('#schedule-allow-guests').prop('checked',true).trigger('change');
            // $('#guests-access-time-container').addClass('show');
            $('#schedulerTitleErrorInner').remove();
            $('#schedulerStartDateErrorInner').remove();
            $('#schedulerEndDateErrorInner').remove();
            $('#schedulerSummaryErrorInner').remove();
            $('#schedulerGeneralMessageInner').remove();
            $('#schedulerStartDateErrorInner').remove();         //card code 500
            $('#moderator-email-field').val('')
            $('#invited-moderators-select > div').remove()
            $("#schedule_start_time").val(startTime);           //card id 756         
            $("#schedule_start_time_input").val(startTime);     //card id 756  
            $('#enhanced-access-security').removeClass('expanded');
            $('#enhanced-access-security-button').html('<i class="fas fa-plus"></i> Enhanced security');
            // $('#additional-options-scheduler').removeClass('expanded');
            // $('#additional-options-button').html('<i class="fas fa-plus"></i> Additional Options');
            $(`#recurring_daily`).prop('checked', false)
            $(`#recurring_weekly`).prop('checked', false)
            $(`#recurring_monthly`).prop('checked', false)
            $('#moderators-access-time').val(15)
            this.membersTimeInput.val('0'+5);
            $('#guests-access-time').val('0'+0)
            this.modsCanAccessKino.val(15);
            this.membersCanAccessKino.val('0'+5);
            this.updateInputsDate();
            this.userDiffTime = 30;
            if(!$('#recurring_daily').is(':checked') || !$('#recurring_weekly').is(':checked') || !$('#recurring_monthly').is(':checked')){
                $('#keep-chat-checkbox').prop({'disabled': true, 'checked': false})
            }
            
            $('#schedule_start_date').val(moment().format("YYYY-MM-DD"))
            // reset time on close
            let current_time_local = moment();
            let selection_index_after = 0
            let selection_index_after_max = 2
            let current_selection_time = moment();
            
            Array.from($('#schedule_start_time').children()).forEach(el => {
                current_selection_time = moment(el.value, 'hh:mm A')
                if(!current_selection_time.isBefore(current_time_local)) {
                    selection_index_after++;
                }
                if(selection_index_after_max == selection_index_after) {
                    $('#schedule_start_time').val(el.value);
                    $('#schedule_start_time_input').val(el.value);      //card id 756
                }
            })

            // selecting end date on load
            // console.log(current_selection_time.format('YYYY-MM-DD hh:mm A'))
            $('#schedule_end_date').val(current_selection_time.format('YYYY-MM-DD'))
            $('#schedule_end_time').val(current_selection_time.format('hh:mm A'))
            
            //clear selected members
            this.selectedMembersEmails=[];
            this.memberParticipantsContainer.find(".user-container").remove();
            // this.hideMembersTimeContainer()
        });

        $('#sch-title').on('input paste change', e => {
            $('#submit_schedule').attr('disabled', false)
            $('#schedulerTitleErrorInner').remove();
        })
       
        $('#schedule_start_date').on('paste change', e => {
            if(this.previousScheduleStartDate != $('#schedule_start_date').val()) {
                $('#submit_schedule').attr('disabled', false)
            }
            $('#schedulerStartDateErrorInner').remove();
            $('#schedulerEndDateErrorInner').remove();
            // console.log(moment($('#schedule_start_date').val()).isAfter($('#schedule_end_date').val()));
            let timeValue = $('#schedule_start_time_input');
            this.checkIfTimeIsCorrect(timeValue);
            this.updateInputsDate();
            
        })
        // card id 689 begin
        $('#schedule_start_time').on('paste change', e => {
            $('#submit_schedule').attr('disabled', false)
            $('#schedulerStartDateErrorInner').remove();
            $('#schedulerEndDateErrorInner').remove();
            this.updateInputsDate();
            this.populateInputOneHourPrior('moderator');
            this.populateInputOneHourPrior('member');
            this.populateInputOneHourPrior('guest');
        })
        // card id 689 end
        $('#schedule_end_time').on('paste change', e => {
            $('#submit_schedule').attr('disabled', false)
            $('#schedulerStartDateErrorInner').remove();
            $('#schedulerEndDateErrorInner').remove();
        })

        $('#schedule_end_date').on('input paste change', e => {
            if(this.previousScheduleEndDate != $('#schedule_end_date').val()) {
                $('#submit_schedule').attr('disabled', false)
            }
            $('#schedulerStartDateErrorInner').remove();
            $('#schedulerEndDateErrorInner').remove();
            // card id 689 begin
            let selectedBeginDate = $('#schedule_start_date').val();
            let selectedEndDate = $('#schedule_end_date').val();
            if(moment(selectedBeginDate).isBefore(selectedEndDate)){
                Array.from($('#schedule_end_time').children()).forEach(el => {
                    $(el).prop('disabled', false);
                })
            }else{
                this.updateInputsDate();
            }
            // card id 689 end
        })
        // $('#schedule_duration').on('input paste change', e => {
        //     $('#submit_schedule').attr('disabled', false)
        //     $('#schedulerStartDateErrorInner').remove();
        //     $('#schedulerEndDateErrorInner').remove();
        //     $('#schedulerStartDateErrorInner').remove();             //card code 500
        // })
        $('#sch-summary').on('input paste change', e => {
            $('#submit_schedule').attr('disabled', false)
            $('#schedulerSummaryErrorInner').remove();
        })

        this.htmlList=$("#schedules-table");

        if(this.htmlList){
            this.listSchedules();
        }

        this.wasKeepChatsChecked = false;
        $('#recurring_daily').on('change', e => {
            this.wasKeepChatsChecked = $('#keep-chat-checkbox').is(':checked')
            $('#keep-chat-checkbox').prop({'disabled': true, 'checked': false})
            if(e.target.checked) {
                $('#recurring_weekly').prop('checked', false)
                $('#recurring_monthly').prop('checked', false)
                $('#keep-chat-checkbox').prop('disabled', false)
                if(this.wasKeepChatsChecked) $('#keep-chat-checkbox').prop('checked', true)
            }
            $('#submit_schedule').prop('disabled', false)
        })
        $('#recurring_weekly').on('change', e => {
            this.wasKeepChatsChecked = $('#keep-chat-checkbox').is(':checked')
            $('#keep-chat-checkbox').prop({'disabled': true, 'checked': false})
            if(e.target.checked) {
                $('#recurring_daily').prop('checked', false)
                $('#recurring_monthly').prop('checked', false)
                $('#keep-chat-checkbox').prop('disabled', false)
                if(this.wasKeepChatsChecked) $('#keep-chat-checkbox').prop('checked', true)
            }
            $('#submit_schedule').prop('disabled', false)
        })
        $('#recurring_monthly').on('change', e => {
            this.wasKeepChatsChecked = $('#keep-chat-checkbox').is(':checked')
            $('#keep-chat-checkbox').prop({'disabled': true, 'checked': false})
            if(e.target.checked) {
                $('#recurring_daily').prop('checked', false)
                $('#recurring_weekly').prop('checked', false)
                $('#keep-chat-checkbox').prop('disabled', false)
                if(this.wasKeepChatsChecked) $('#keep-chat-checkbox').prop('checked', true)
            }
            $('#submit_schedule').prop('disabled', false)
        })

        $('#keep-chat-checkbox').on('click', function(){
            $('#submit_schedule').prop('disabled', false)
        })

        let sch = this;
        $('#moderator-email-field').on('keypress', e => {
            let KeyID = e.keyCode;
            $('#submit_schedule').attr('disabled', false)
            if(KeyID == 13 || KeyID == 32 || KeyID == 44) {
                e.preventDefault()
                let item = $('#moderator-email-field').val()
                if(!this.validateEmail(item))   return false
                if(!item.length) return false;
                $('#moderator-email-field').val('')
                if($('#invited-moderators-select').find(`span.email[data-email="${item}"]`).length){
                    return
                }
                $('#moderator-email-field').before(`
                    <div class="user-container">
                        <div class="user-detail">
                            <span class="email" data-email="${item}">${item}</span>
                        </div>
                        <div class="control">
                            <div class="remove-icon">
                                <span><i class="fas fa-times"></i></span>
                            </div>
                        </div>
                    </div>
                `)
                $('#invited-moderators-select').scrollTop($('#invited-moderators-select').height() * 100000000);
            }
        }).on('focus', e => {
            this.focusInModeratorField = true
            $('#invited-moderators-select').addClass('focused')
        }).on('focusout', e => {
            this.focusInModeratorField = false
            setTimeout(() => {
                if(this.focusInModeratorField) return false;
                $('#invited-moderators-select').removeClass('focused')
                let item = $('#moderator-email-field').val()
                $('#moderator-email-field').val('')
                if(!this.validateEmail(item))   return $('#moderator-email-field').val('')
                $('#submit_schedule').attr('disabled', false)
                if($('#invited-moderators-select').find(`span.email[data-email="${item}"]`).length){
                    return
                }
                $('#moderator-email-field').before(`
                    <div class="user-container">
                        <div class="user-detail">
                            <span class="email" data-email="${item}">${item}</span>
                        </div>
                        <div class="control">
                            <div class="remove-icon">
                                <span><i class="fas fa-times"></i></span>
                            </div>
                        </div>
                    </div>
                `)
                $('#invited-moderators-select').scrollTop($('#invited-moderators-select').height() * 100000000);
            }, 250);
        })

        $('#invited-moderators-select').on('click', '.remove-icon', e => {
            let elem = $(e.target).closest('.user-container')
            elem.remove();
            $('#submit_schedule').attr('disabled', false)
        })

        $('#moderators-access-time').on('input', function(e){
            $(this).val(e.currentTarget.value.replace(/[^0-9]/g, ''));
            let val = e.currentTarget.value
            let regTest = sch.strTest.timerTestScheduler(val);
            $(this).val(regTest);
            if(regTest > 1 && regTest < 60){
                $('#moderators-access-time-span').html('minutes')
            }
            if(regTest == 1){
                $('#moderators-access-time-span').html('minute')
            }
            // if(regTest == 60){
            //     $('#moderators-access-time-span').html('hour')
            //     $(this).val('01')
            // }
            $('#submit_schedule').attr('disabled', false)
            sch.modsCanAccessKino.html(regTest)
        }).on('blur', function(e){
            if(e.currentTarget.value < 10 && e.currentTarget.value != ''){
                $(this).val('0'+ parseInt(e.currentTarget.value))
                // t.defaultStateMinutes = '0'+ parseInt(e.currentTarget.value)
                sch.modsCanAccessKino.html('0'+ parseInt(e.currentTarget.value))
            }
            if(e.currentTarget.value == ''){
                $(this).val('00')
                // t.defaultStateMinutes = 0;
                $('#moderators-access-time-span').html('minutes')
                sch.modsCanAccessKino.html('00');
            }
        })
        $('#moderator_join_time').on('blur', function(e){
            sch.updateOneHourPriorInputs($('#moderator_join_time_input'));
        })
        $('#moderator_join_time').on('change',function(e){
            console.log("Last saved moderator join time",sch.oldTimePickedModeratorJoin)
            console.log("Saving moderator join time",$(this).val())
            if($(this).val()!=sch.oldTimePickedModeratorJoin){
                $('#submit_schedule').attr('disabled', false)
            }
        })
        $('#moderator_join_time_input').on('blur', function(e){
            sch.updateOneHourPriorInputs($(this));
            console.log("Last saved moderator join time",sch.oldTimePickedModeratorJoin)
            console.log("Saving moderator join time",$(this).val())
            if($(this).val()!=sch.oldTimePickedModeratorJoin){
                $('#submit_schedule').attr('disabled', false)
            }
        }).on('focus', function(e){
            sch.oldTimePickedModeratorJoin = e.currentTarget.value;
        })

        $('#member_join_time').on('blur', function(e){
            sch.updateOneHourPriorInputs($('#member_join_time_input'));
            if($(this).val()!=sch.oldTimePickedMemberJoin){
                $('#submit_schedule').attr('disabled', false)
            }
        })

        $('#member_join_time').on('change',function(e){
            if($(this).val()!=sch.oldTimePickedMemberJoin){
                $('#submit_schedule').attr('disabled', false)
            }
        })

        $('#member_join_time_input').on('blur', function(e){
            sch.updateOneHourPriorInputs($(this));
            if($(this).val()!=sch.oldTimePickedMemberJoin){
                $('#submit_schedule').attr('disabled', false)
            }
        }).on('focus', function(e){
            sch.oldTimePickedMemberJoin = e.currentTarget.value;
        })

        $('#guest_join_time').on('blur', function(e){
            sch.updateOneHourPriorInputs($('#guest_join_time_input'));
            if($(this).val()!=sch.oldTimePickedGuestJoin){
                $('#submit_schedule').attr('disabled', false)
            }
        })

        $('#guest_join_time').on('change',function(e){
            if($(this).val()!=sch.oldTimePickedGuestJoin){
                $('#submit_schedule').attr('disabled', false)
            }
        })
        $('#guest_join_time_input').on('blur', function(e){
            sch.updateOneHourPriorInputs($(this));
            if($(this).val()!=sch.oldTimePickedGuestJoin){
                $('#submit_schedule').attr('disabled', false)
            }
        }).on('focus', function(e){
            sch.oldTimePickedGuestJoin = e.currentTarget.value;
        })

        $('#schedule-allow-guests').on('change', function(){
            if($(this).is(':checked')){
                // $('#guests-access-time-container').addClass('show')
                $('#guests-access-time').prop({'disabled': false})
            }else{
                // $('#guests-access-time-container').removeClass('show')
                $('#guests-access-time').prop({'disabled': true})
            }
            $('#submit_schedule').attr('disabled', false)
        })

        $('#guests-access-time').on('input', function(e){
            $(this).val(e.currentTarget.value.replace(/[^0-9]/g, ''));
            let val = e.currentTarget.value
            let regTest = sch.strTest.timerTestScheduler(val);
            $(this).val(regTest);
            if(regTest > 1 && regTest <= 60){
                $('#guests-access-time-span').html('minutes')
            }
            if(regTest == 1){
                $('#guests-access-time-span').html('minute')
            }
            // if(regTest == 60){
            //     $('#guests-access-time-span').html('hour')
            //     $(this).val('60')
            // }
            $('#submit_schedule').attr('disabled', false)
        }).on('blur', function(e){
            if(e.currentTarget.value < 10 && e.currentTarget.value != ''){
                $(this).val('0'+ parseInt(e.currentTarget.value))
                // t.defaultStateMinutes = '0'+ parseInt(e.currentTarget.value)
            }
            if(e.currentTarget.value == ''){
                $(this).val('00')
                // t.defaultStateMinutes = 0;
                $('#guests-access-time-span').html('minutes')
            }
        })
        try {
            // console.log(document.URL)
            let scheduler_init_modal = document.URL.split('?');
            // begin card 769
            let timezoneValue = $('#timezone_field').val();
            if(scheduler_init_modal.length) {
                scheduler_init_modal = scheduler_init_modal[1]
                scheduler_init_modal = scheduler_init_modal.split('=')
                //begin card 802
                if(scheduler_init_modal[0] == "schedule" && scheduler_init_modal[1] == "true" && timezoneValue !== null) {
                    // show schedule modal
                    console.log("Show schedule modal")
                    let scheduleSetup=new SchedulerWizard();
                    scheduleSetup.showSetup();
                    scheduleSetup.onClose=()=>{
                        scheduleSetup=undefined;
                    };
                    scheduleSetup.onSuccess=this.onScheduleSuccess.bind(this);
                } 
                else {
                    if(scheduler_init_modal[0] == "schedule" && scheduler_init_modal[1] == "true" && timezoneValue === null){
                        $('#errorScheduleModal').modal('show')
                    }
                }
                //end card 802
            // end card 769
            }
        } catch (error) {
            // console.error(error)
        }
        
        // $('#additional-options-button').on('click', function(){
        //     if($('#additional-options-scheduler').hasClass('expanded')){
        //         $('#additional-options-scheduler').removeClass('expanded')
        //         $(this).html('<i class="fas fa-plus"></i> Additional Options')
        //     }else{
        //         $('#additional-options-scheduler').addClass('expanded')
        //         $(this).html('<i class="fas fa-minus"></i> Additional Options')
        //     }
        // })
        
        $('#enhanced-access-security-button').on('click', function(){
            if($('#enhanced-access-security').hasClass('expanded')){
                $('#enhanced-access-security').removeClass('expanded')
                $(this).html('<i class="fas fa-plus"></i> Enhanced security')
            }else{
                $('#enhanced-access-security').addClass('expanded')
                $(this).html('<i class="fas fa-minus"></i> Enhanced security')
            }
        });

        // this.populateInputOneHourPrior('moderator');
    }

    Scheduler(modal,formid) {
        this.modal=modal;
        this.formid=formid;
        this.previousScheduleStartDate = ''
        this.previousScheduleEndDate = ''
        this.token=$('meta[name="csrf-token"]').attr('content');
    }

    pastKinos(e) {
        $('#past-kinos-modal').modal()

        $('#schedules-past-kino-table-body').html("<tr><td colspan='6'>Loading...</td></tr>");
        $.ajax({
            url: `/schedule/past-kino`,
            type: "GET",
            beforeSend: (xhr) => {xhr.setRequestHeader('X-CSRF-TOKEN', this.token);}
        }).done((res, call, xhr) => {
            if(xhr.status == 200) {
                $('#schedules-past-kino-table-body').html(``);
                res.forEach(el => {
                    // <td>${el.host}</td>
                    $('#schedules-past-kino-table-body').append(`
                        <tr>
                            <td>${el.start_date}</td>
                            <td>${el.title}</td>
                            <td>${el.start_time}</td>
                            <td>${el.duration}</td>
                        </tr>
                    `);
                })
            } else {
                swal.fire(res.message, 'An error Occurred!', 'error');
            }
        });
    }

    validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    async addSchedule(callback) {
        var data=$(this.formid).serializeArray();
        let sch = this;
        
        console.log(data);
        let schedule_start_date = data.filter(el => {
            return el.name == "schedule_start_date"
        }).map(el => {
            return el.value
        })[0];
        
        let schedule_end_date = data.filter(el => {
            return el.name == "schedule_end_date"
        }).map(el => {
            return el.value
        })

        let schedule_start_time = data.filter(el => {
            return el.name == "schedule_start_time_input"   //card id 756
        }).map(el => {
            return moment(el.value, 'hh:mm AA')
        })[0];
        // console.log(schedule_start_time);
        let schedule_end_time = data.filter(el => {
            return el.name == "schedule_end_time_input"     //card id 756
        }).map(el => {
            return moment(el.value, 'hh:mm AA')
        })[0];
        
        let schedule_duration = data.filter(el => {
            return el.name == "schedule_duration"
        }).map(el => {
            return el.value
        })[0];
        
        let keepChats = $('#keep-chat-checkbox').is(':checked')
        // card 745
        // console.log(schedule_start_date)
        // console.log(schedule_end_date[0])
        // if(moment(schedule_start_date, 'YYYY-MM-DD').isSame(schedule_end_date[0], 'YYYY-MM-DD')){
        //     console.log('they are the same dates');
        //     console.log(schedule_start_time.format('hh:mm AA'))
        //     console.log($('#schedule_end_time').val())

        //     if(schedule_start_time.format('hh:mm AA') == schedule_end_time.format('hh:mm AA')){
        //         console.log('they have the same time');
        //     }
        // }
        // end card 745

        let start_date = moment(schedule_start_date, 'YYYY-MM-DD').add(schedule_start_time.hour(), 'hours').add(schedule_start_time.minute(), 'minutes').format('YYYY-MM-DD HH:mm')
        let end_date = moment(schedule_end_date, 'YYYY-MM-DD').add(schedule_end_time.hour(), 'hours').add(schedule_end_time.minute(), 'minutes').format('YYYY-MM-DD HH:mm')
        // let end_date = moment(start_date, 'YYYY-MM-DD HH:mm').add(schedule_duration, 'minutes').format('YYYY-MM-DD HH:mm')

        data.push({
            name: "start_date",
            value: start_date
        })
        data.push({
            name: "end_date",
            value: end_date
        })

        let moderators = []
        $('#invited-moderators-select').find('span.email[data-email]').each((index, el) => {
            moderators.push($(el).data('email'))
        })

        // console.log(moderators)

        data.push({
            name: 'moderators',
            value: moderators
        })

        //send members
        let members=this.selectedMembersEmails;
        // console.log("Selected members email",members);
        if(!members.length){
            members=[];
        }
        data.push({
            name: 'members',
            value: members
        });

        data.push({
            name: 'keep_chats',
            value: keepChats
        })

        data.push({
            name: 'moderators_join_before',
            value: $('#moderator_join_time_input').attr('joinbefore')
        })

        data.push({
            name: 'members_join_before',
            value: $('#member_join_time_input').attr('joinbefore')
        })

        data.push({
            name: 'guest_join_before',
            value: $('#guest_join_time_input').attr('joinbefore')
        })

        return await $.ajax({
             url: "/schedule/add",
             data: data,
             type: "POST",
             beforeSend: (xhr) => {xhr.setRequestHeader('X-CSRF-TOKEN', this.token);},
             statusCode: {
                422: function(r) {
                    if(r.responseJSON.errors.title){
                        // swal.fire(r.responseJSON.errors.title[0], '', 'error');
                        $('#schedulerTitleErrorInner').remove();
                        $('#schedulerTitleError').append(`<div id="schedulerTitleErrorInner" class="error_kino text-align-left">⚠ ${r.responseJSON.errors.title[0]}</div>`);
                    } else if(r.responseJSON.errors.start_date){
                        // swal.fire(r.responseJSON.errors.start_date[0], 'Please verify your profile\'s timezone is correct', 'error');
                        $('#schedulerStartDateErrorInner').remove();
                        $('#schedulerEndDateErrorInner').remove();
                        $('#schedulerStartDateError').append(`<div id="schedulerStartDateErrorInner" class="error_kino text-align-left">⚠ ${r.responseJSON.errors.start_date[0]}.
                                                                Please verify if your profile\'s timezone is correct
                                                            </div>`);
                    }else if(r.responseJSON.errors.end_date){
                        // swal.fire(r.responseJSON.errors.end_date[0], '', 'error')
                        $('#schedulerEndDateErrorInner').remove();
                        $('#schedulerStartDateErrorInner').remove();
                        $('#schedulerStartDateError').append(`<div id="schedulerStartDateErrorInner" class="error_kino text-align-left">⚠ ${r.responseJSON.errors.end_date[0]}</div>`);
                    }else if(r.responseJSON.errors.summary){
                        // swal.fire(r.responseJSON.errors.summary[0], '', 'error');
                        $('#schedulerSummaryErrorInner').remove();
                        $('#schedulerSummaryError').append(`<div id="schedulerSummaryErrorInner" class="error_kino text-align-left">⚠ ${r.responseJSON.errors.summary[0]}</div>`);
                    }else{
                    //   swal.fire(r.responseJSON.message, '', 'error');
                      $('#schedulerGeneralMessageInner').remove();
                      $('#schedulerGeneralMessage').append(`<div class="alert alert-danger" role="alert" id="schedulerGeneralMessageInner">${r.responseJSON.message}</div>`);
                    }
                    callback(false)
                },
                // Begin card code 500
                400: function(r){
                    // console.log('debug: ', r);
                    if(r.responseJSON.message){
                        $('#schedulerStartDateErrorInner').remove();
                        $('#schedulerStartDateError').append(`<div id="schedulerStartDateErrorInner" class="error_kino text-align-left">⚠ ${r.responseJSON.message}</div>`);
                    }
                }
                // End card code 500
              }
          }).done((res) => {
              this.listSchedules();
            if(res.success===true){
                callback(res)
            }else{
                callback(false)
                // console.log("errors-res", res)
                // swal.fire(res.message, '', 'error');
                $('#schedulerGeneralMessageInner').remove();
                $('#schedulerGeneralMessage').append(`<div class="alert alert-danger" role="alert" id="schedulerGeneralMessageInner">${res.message}</div>`);
            }

          });
    }

    declineInvidation(id, modal) {
        $.ajax({
            url: `/schedule/decline/${id}`,
            type: "POST",
            beforeSend: (xhr) => {xhr.setRequestHeader('X-CSRF-TOKEN', this.token);}
        }).done((res, call, xhr) => {
            if(xhr.status == 200) {
                swal.fire(res.message, 'You declined this invitation!', 'success');
                $('#scheduleModal').modal("hide");
                this.listSchedules()
            } else {
                swal.fire(res.message, 'An error Occurred!', 'error');
            }
            if(modal) {
                modal.modal('hide')
            }
        });
    }

    acceptInvitation(id, modal) {
        $.ajax({
            url: `/schedule/accept/${id}`,
            type: "POST",
            beforeSend: (xhr) => {xhr.setRequestHeader('X-CSRF-TOKEN', this.token);}
        }).done((res, call, xhr) => {
            if(xhr.status == 200) {
                swal.fire(res.message, 'You accepted this invitation!', 'success');
                $('#scheduleModal').modal("hide");
                this.listSchedules()
            } else {
                swal.fire(res.message, 'An error Occurred!', 'error');
            }
            if(modal) {
                modal.modal('hide')
            }
        });
    }

    cancelSchedule() {
        if(this.cancelScheduleId) {
            axios.post(`/schedule/${this.cancelScheduleId}`, {
                _method: 'delete'
            }).then(res => {
                // console.log('deleted')
                this.listSchedules()
            }).catch(err => {
                console.error(err)
            }).finally( () => {
                $('#cancel-schedule-modal').modal('hide');
            })
        }
    }

    prependItemToList(item) {
        let editBtn=$("<button/>",{
            class:"mui-btn mui-btn--primary mui-btn--flat mui-btn--small mr-1 ml-0 text-500 my-0",
            html: `Edit`
        }).on("click",(e) => {
            e.preventDefault();
            e.stopPropagation();
            let scheduleSetup=new SchedulerWizard(item);
            scheduleSetup.showSetup();
            scheduleSetup.onClose=()=>{
                scheduleSetup=undefined;
            };
            scheduleSetup.onSuccess=this.onScheduleSuccess.bind(this);
            return
        });
        
        let deleteBtn = $("<button />", {
            class:"mui-btn mui-btn--danger mui-btn--flat mui-btn--small text-500 ml-0 my-0",
            html: `Delete`,
        }).on('click', e => {
            $('#cancel-schedule-modal').modal();
            this.cancelScheduleId = item.id
            return false;
        })

        let downloadCalendarBtn = $("<button/>", {
            class: "mui-btn mui-btn--primary mui-btn--flat mui-btn--small mr-1 text-500 my-0",
            html: `View`,
            target: "_blank",
            rel: "nofollow",
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: "Add to Calendar"
        })

        let acceptedKinoCheckMark = $("<a/>", {
            style: "font-size: 22px",
            class: "text-success",
            html: `<i class="fas fa-check-circle"></i>`
        })
        let declinedKinoCheckMark = $('<a/>', {
            style: "font-size: 22px",
            class: "text-danger",
            html: `<i class="fas fa-times-circle"></i>`
        })

        let acceptInvitationBtn = $('<button/>', {
                class: "btn btn-sm btn-primary",
                html: "Accept"
            }).on('click', () => {
                this.acceptInvitation(item.id)
            })
        let declineInvitationBtn = $('<button/>', {
            class: "btn btn-sm btn-danger",
            html: "Decline"
        }).on('click', (e) => {
            //decline Invitation here
            this.declineInvidation(item.id)
        })

        let schedule_starts = moment(item.starts, 'YYYY-MM-DD hh:mm A') //card id 687
        let schedule_ends = moment(item.ends, 'YYYY-MM-DD hh:mm A')     //card id 687
        let duration = schedule_ends.diff(schedule_starts, 'minutes')
        let actions=$("<div/>",{
            class:"d-flex justify-content-end align-items-center border-0",
            html:[downloadCalendarBtn,item.can_edit ? editBtn :'',item.can_edit ? deleteBtn :'' ]
        })
        let row=$("<tr/>",{
            // <td>${item.host}</td>

            // card 585
            html: [`
                <td>${item.next_event_start_date}</td>
                <td>${item.title}</td>
                <td>${moment.utc(item.event_start_time).format('hh:mm A')}</td>
                <td>${moment.utc(item.event_start_time).add(duration, 'minutes').format('hh:mm A')}</td>
                <td>${ (item.recurring) ? item.recurring : 'One Time' }</td>
            `,                                                                  //card id 687
            $('<td>',{html:[actions]})              
            ]
        }).on('click', (e) => {
            // shows modal with animation and info about the kino
            console.log(item)
            this.showScheduleModal(item)
        });
        this.htmlList.prepend(row);
        // end card 585
    }

    async listSchedules() {
        this.htmlList.html("<tr><td colspan='6'>Loading...</td></tr>");
        return $.ajax({
            url: "/schedule/list",
            type: "POST",
            beforeSend: (xhr) => {xhr.setRequestHeader('X-CSRF-TOKEN', this.token);},
            statusCode: {
            422: function(r) {
                //swal.fire(r.responseJSON.message, '', 'error');
            }
            }
        }).done((res) => {
            try{
            this.htmlList.html("");
            // card 476
            if(!res.length) {
                this.htmlList.append($('<tr />', {
                    html: $('<td />', {
                        colspan: 6,
                        class: "text-center empty",
                        html: [
                            $('<span />', {
                                text: "You have no scheduled Kinos. Click + to schedule."
                            })
                        ]
                    })
                }))
                return
            }
            // end card 476
            $.each(res, (i, schedule) => {
                console.error('Schedule start date ',schedule)
                this.prependItemToList(schedule);
            });
            //Function to paginate the schedules
            // $('#schedule-kino-table').DataTable({
            //     'ordering': false,
            //     'searching': false,
            //     'pagingType': 'numbers'
            // });
            // $('.dataTables_length').addClass('bs-select');
            }catch(e){
                console.error(e)
            }

        });
    }

 
    showScheduleModal(item) {
        let sch = this;
        $('#schedule-info-body').html('');
        $('#schedule-info-footer-buttons').html('')
        // $('#schedule-info-modal-title').html('')
        $('#schedule-info-footer').addClass('d-none');
        $('#schedule-info-modal .modal-header').addClass('d-none');
        this.startLoader( $('#schedule-info-body') );
        // setTimeout(() => {
        //     $('#schedule-info-modal').modal()
        // }, 500);

        axios.get(`/connect/outlook-google/calendar/${item.id}`).then(res => {
            $('#email-schedule-btn').data('id', item.id)
            $('#email-schedule-btn').data('title', item.title)

            $('#add_to_gmail_group a').attr('href', res.data.google)
            $('#add_to_outlook_group a').attr('href', res.data.outlook)
        });
        //.finally( () => {
            this.stopLoader( $('#schedule-info-body') );

            $('#schedule-info-footer').removeClass('d-none');
            $('#schedule-info-modal .modal-header').removeClass('d-none');

            // $('#schedule-info-modal-title').append(`${item.title}`)
            // $('#schedule-info-body').append(`
            //     <div class="row">
            //         <div class="col-1">
            //             <span><i class="far fa-clock"></i></span>
            //         </div>
            //         <div class="col-11">
            //             <span>${item.start_time_info.day_text}, ${item.start_time_info.month} ${item.start_time_info.day_numeric}</span>
            //             <span class="ml-2">${item.start_time_info.start_hour}:${item.start_time_info.start_min} - ${item.start_time_info.end_hour}:${item.start_time_info.end_time} ${item.gmt_timezone}</span>
            //         </div>
            //     </div>
            // `)
            // console.log(item);
            $('#schedule-info-body').append(`
                <div class="item">
                    <div class="title">
                        <span>Title</span>
                    </div>
                    <div class="content">
                        <span>${item.title}</span>
                    </div>
                </div>
            `)
            $('#schedule-info-body').append(`
                <div class="item mt-1">
                    <div class="title">
                        <span>Created on</span>
                    </div>
                    <div class="content">
                        <span>${moment.utc(item.schedule_creation).format('dddd, MMMM Do, YYYY')}</span>
                    </div>
                </div>
            `)
            $('#schedule-info-body').append(`
                <div class="item mt-1">
                    <div class="title">
                        <span>Event date</span>
                    </div>
                    <div class="content">
                        <span>${moment.utc(item.next_event_date_formated).format('dddd, MMMM Do, YYYY')} from ${item.start_time} to ${item.end_time}</span>
                    </div>
                </div>
            `)
            let schedule_starts = moment(item.starts, 'YYYY-MM-DD hh:mm A') //card id 687
            let schedule_ends = moment(item.ends, 'YYYY-MM-DD hh:mm A')     //card id 687
            let duration = schedule_ends.diff(schedule_starts, 'minutes')
            // $('#schedule-info-body').append(`
            //     <div class="item mt-1">
            //         <div class="title">
            //             <span>Start Time</span>
            //         </div>
            //         <div class="content">
            //         <span>${item.start_time}</span>   
            //         </div>
            //     </div>
            // `)                                                   //card id 687
            // $('#schedule-info-body').append(`
            //     <div class="item mt-1">
            //         <div class="title">
            //             <span>End Time</span>
            //         </div>
            //         <div class="content">
            //         <span>${item.end_time}</span>
            //         </div>
            //     </div>
            // `)                                                                              //card id 687
            $('#schedule-info-body').append(`
                <div class="item mt-1">
                    <div class="title">
                        <span>Scheduled Kino Link</span>
                    </div>
                    <div class="content">
                        <a href="${item.location}">${item.location}</a>
                    </div>
                </div>
            `)
            if(item.recurring) {
                $('#schedule-info-body').append(`
                    <div class="item mt-1">
                        <div class="title">
                            <span>Recurring</span>
                        </div>
                        <div class="content">
                        <span>${ item.recurring_text }</span>
                        </div>
                    </div>
                `)
            }

            // EXPAND MODERATORS
            if(item.moderators && item.moderators.length) {
                $('#schedule-info-body').append(`
                    <div class="item mt-1 item-expandable">
                        <div class="title cursor-pointer" id="scheduler-info-moderators-button">
                            ${sch.caretDownSvg}
                            <span>Moderators</span>
                        </div>
                        <div class="content scheduler-info-moderators-hidden">
                        <span>${ item.moderators.join(', ')}</span>
                        </div>
                    </div>
                `)
            }
            $('#scheduler-info-moderators-button').on('click', function(){
                if($('.scheduler-info-moderators-hidden').hasClass('expanded')){
                    $('.scheduler-info-moderators-hidden').removeClass('expanded')
                    $(this).html(`${sch.caretDownSvg} Moderators`)
                    $(this).removeClass('expanded')
                }else{
                    $('.scheduler-info-moderators-hidden').addClass('expanded')
                    $(this).html(`${sch.caretUpSvg} Moderators`)
                    $(this).addClass('expanded')
                }
            });
            
            // EXPAND MEMBERS
            if(item.members && item.members.length){
                $('#schedule-info-body').append(`
                    <div class="item mt-1 item-expandable">
                        <div class="title cursor-pointer" id="scheduler-info-members-button">
                            ${sch.caretDownSvg}
                            <span>Members</span>
                        </div>
                        <div class="content scheduler-info-members-hidden">
                        <span>${ item.members.join(', ')}</span>
                        </div>
                    </div>
                `)
            }
            $('#scheduler-info-members-button').on('click', function(){
                if($('.scheduler-info-members-hidden').hasClass('expanded')){
                    $('.scheduler-info-members-hidden').removeClass('expanded')
                    $(this).html(`${sch.caretDownSvg} Members`)
                    $(this).removeClass('expanded')
                }else{
                    $('.scheduler-info-members-hidden').addClass('expanded')
                    $(this).html(`${sch.caretUpSvg} Members`)
                    $(this).addClass('expanded')
                }
            });

            // EXPAND GUESTS
            if(item.guests && item.guests.length) {
                $('#schedule-info-body').append(`
                    <div class="item mt-1 item-expandable">
                        <div class="title cursor-pointer" id="scheduler-info-guests-button">
                            ${sch.caretDownSvg}
                            <span>Guests</span>
                        </div>
                        <div class="content scheduler-info-guests-hidden">
                        <span>${ item.guests.join(', ')}</span>
                        </div>
                    </div>
                `)
            }
            $('#scheduler-info-guests-button').on('click', function(){
                if($('.scheduler-info-guests-hidden').hasClass('expanded')){
                    $('.scheduler-info-guests-hidden').removeClass('expanded')
                    $(this).html(`${sch.caretDownSvg} Guests`)
                    $(this).removeClass('expanded')
                }else{
                    $('.scheduler-info-guests-hidden').addClass('expanded')
                    $(this).html(`${sch.caretUpSvg} Guests`)
                    $(this).addClass('expanded')
                }
            });


            let readMore = item.summary.length >= 200 ? true : false;
            $('#schedule-info-body').append(`
                <div class="item mt-1">
                    <div class="title">
                        <span>Summary</span>
                    </div>
                    <div class="content">
                    <span class="m-0" id="summary-content">${(item.summary.trim().length) ? (readMore ? item.summary.substring(0, 200) + "..." : item.summary) : 'No description added'}</span>
                    <span class="show-more-summary">Show more</span>
                    </div>
                </div>
            `)  
            // SHOW MORE ON SUMMARY
            if (item.summary.length >= 200) {
                $('.show-more-summary').show();
            }
              
            $('.show-more-summary').on('click', function() {
                if(readMore){
                    readMore = false;
                    $('#summary-content').text(item.summary);
                } else {
                    readMore = true;
                    $('#summary-content').text(`${item.summary.substring(0, 200)}...`);
                }
                $(this).text() === 'Show more' ? $(this).text('Show less') : $(this).text('Show more');
            });
            $('#schedule-info-modal').modal()
        // })
    }

    startLoader(element) {
        element.append(`<div class="lazy-load-screen">
            <div class="loader">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">

                </svg>
            </div>
        </div>`)
    }

    stopLoader(element) {
        element.find('.lazy-load-screen').remove();
    }

    // card id 689 and 756 begin
    updateInputsDate() {
        let selectedTime = $('#schedule_start_time').val();
        let selectedTimeInput = $('#schedule_start_time_input').val();
        //variables that serve to calculate custom timing
        let UserCustomDiffTime = moment(selectedTimeInput, 'hh:mm A').add(this.userDiffTime, 'minutes').format('hh:mm A');
        $('#schedule_end_time').val(UserCustomDiffTime)
        $('#schedule_end_time_input').val(UserCustomDiffTime)

        Array.from($('#schedule_end_time').children()).forEach(el => {
            $(el).prop('disabled', false);
            if(moment.utc(selectedTimeInput, 'hh:mm A').isAfter(moment.utc($(el).val(), 'hh:mm A'), 'minute')){ //card id 745
                $(el).prop('disabled', true);
            }
        })

        //card id 745 begin
        if(moment($('#schedule_start_date').val()).isAfter($('#schedule_end_date').val())){
            $('#schedule_end_date').val($('#schedule_start_date').val());
        }
        if(moment($('#schedule_start_date').val()).isBefore($('#schedule_end_date').val())){
            Array.from($('#schedule_end_time').children()).forEach(el => {
                $(el).prop('disabled', false);
            })
        }
        //card id 745 end

        //check if schedule is being set near the end of the day
        if(selectedTime == '11:00 PM' || selectedTime == '11:15 PM' || selectedTime == '11:30 PM' || selectedTime == '11:45 PM'){
            $('#schedule_end_time').val('11:45 PM')
        }

    }
    // card id 689 and 756 end
    
    //card id 756 begin
    checkIfTimeIsCorrect(input, outsideOneHourBefore=false){
        let oldValue = input.val();
        let inputId = input.attr("id");
        let timeRegex = /^(0?[1-9]|1[0-2]):([0-5]\d)\s((?:A|P)\.?M\.?)$/;
        let timeSimpleRegex = /^(0?[1-9]|1[0-2]):([0-5]\d)\s?$/;
        // let stringToAM = /^(0?[1-9]|1[0-2])([0-5])([0-9])$/;
        // let stringToPM = /^(0?[1-9]|1[0-2])([0-5][0-9][0]{1,1})$/;
        let simpleTimeRegex = /^(0?[1-9]|1[0-2])([0-5])([0-9])$/;
        let twentyFourHourRegex = /^([0-9]|[01][0-9]|2[0-3])([0-5][0-9])$/;
        console.log(oldValue, inputId)

        if(simpleTimeRegex.test(oldValue) || twentyFourHourRegex.test(oldValue)){
            let hours, minutes, timeValue;
            let time = oldValue;
            let amOrPm = '';
            if(time.length == 3){
                hours = "0"+time.substring(0,1);
                minutes = time.substring(1,3);
                // alert('AM?')
            }else if(time.length == 4){
                // alert('PM?')
                hours = time.substring(0,2);
                minutes = time.substring(2,4);
            }

            if(hours < 12 && hours >= 7){
                amOrPm = "AM";
            }
            if(hours == 12 || (hours >=1 && hours < 7)){
                amOrPm = "PM";
            }

            if(hours == 0){
                hours = 12;
                amOrPm = "AM";
            }

            if(hours > 12){
                hours = moment(hours, ['HH']).format('hh')
                // console.log(hours)
                amOrPm = "PM";
            }

            timeValue = `${hours}:${minutes} ${amOrPm}`;
            input.val(timeValue);
            // console.log(timeValue);
            return;
        }


        if(timeSimpleRegex.test(oldValue)){
            let hour = moment().hour();
            if(hour >= 12){
                if(inputId == 'schedule_start_time_input'){
                    if(moment($('#schedule_start_date').val()).isSame(moment(), 'day')){
                        input.val(`${oldValue.trim()} PM`);
                        return;
                    }
                    input.val(`${oldValue.trim()} AM`);
                    return;
                }
                input.val(`${oldValue.trim()} PM`);
            }else{
                input.val(`${oldValue.trim()} AM`);
            }
            return;
        }
        // console.log('time match: ', timeRegex.test(oldValue))
        if(outsideOneHourBefore){
            if(inputId == 'moderator_join_time_input'){
                input.val(this.oldTimePickedModeratorJoin)
                return
            }
            if(inputId == 'member_join_time_input'){
                input.val(this.oldTimePickedMemberJoin)
                return
            }
            if(inputId == 'guest_join_time_input'){
                input.val(this.oldTimePickedGuestJoin)
                return
            }
        }
        if(!timeRegex.test(oldValue)){
            console.log(inputId);
            if(inputId == "schedule_start_time_input"){
                input.val(this.oldTimePicked);
            }else if(inputId == 'schedule_end_time_input'){
                input.val()
            }else if(inputId == 'moderator_join_time_input'){
                input.val(this.oldTimePickedModeratorJoin)
            }else if(inputId == 'member_join_time_input'){
                input.val(this.oldTimePickedMemberJoin)
            }else if(inputId == 'guest_join_time_input'){
                input.val(this.oldTimePickedGuestJoin)
            }
            return;
        }
    }

    //card id 756 end
    
    changeSchedulerDuration(){
        let startTime = moment($('#schedule_start_time_input').val(), 'hh:mm A');
        let endTime = moment($('#schedule_end_time_input').val(), 'hh:mm A');
        this.userDiffTime = endTime.diff(startTime, 'minutes')

        // console.log(startTime)
        // console.log(endTime)
        // console.log(this.userDiffTime)
    }

    handleMembersInput(){
        let sch = this;
        this.memberParticipantsContainer=$('#schedule-members-container');
        // this.excludeSearchResults=$('#search-exclude-list-results');
        this.scheduleMembersInput=$('#schedule-members-input');
        this.selectedMembersEmails=[];
        this.typingTimeout=0;
        this.memberParticipantsContainer.on('click',e=>{
            this.scheduleMembersInput.trigger('focus');
        });
        this.membersTimeInputContainer = $('#members-access-time-container');
        this.membersTimeInput = $('#members-access-time');
        this.timerSpan = $('#members-access-time-span');

        this.scheduleMembersInput.on('keypress', e => {
            this.memberParticipantsContainer.scrollTop(this.memberParticipantsContainer.height() * 100000000);
            let KeyID = e.keyCode;
            if(KeyID == 13 || KeyID == 32 || KeyID == 44) {
                e.preventDefault()
                let item = this.scheduleMembersInput.val()
                if(!this.validateEmail(item))   return false
                if(!item.length) return false;
                this.scheduleMembersInput.val("");
                if(this.selectedMembersEmails.includes(item)){
                    return;
                }
                this.addToMembersList(item);
                // this.membersTimeInputContainer.addClass('show')
                // this.membersTimeInput.prop({'disabled': false})
            }
        }).on('focus', e => {
            this.memberParticipantsContainer.addClass('focused')
            this.memberParticipantsContainer.scrollTop(this.memberParticipantsContainer.height() * 100000000);
        }).on('focusout',e=>{
            this.memberParticipantsContainer.removeClass('focused')
            let item = this.scheduleMembersInput.val()
            if(!this.validateEmail(item))   return false
            if(!item.length) return false;
            this.scheduleMembersInput.val("");
            if(this.selectedMembersEmails.includes(item)){
                return;
            }
            this.addToMembersList(item);
            // this.membersTimeInputContainer.addClass('show')
            // this.membersTimeInput.prop({'disabled': false})
            // this.hideMembersTimeContainer()
        });

        sch.membersTimeInput.on('input', function(e){
            $(this).val(e.currentTarget.value.replace(/[^0-9]/g, ''));
            let val = e.currentTarget.value
            let regTest = sch.strTest.timerTestScheduler(val);
            $(this).val(regTest);
            if(regTest > 1 && regTest < 60){
                sch.timerSpan.html('minutes')
            }
            if(regTest == 1){
                sch.timerSpan.html('minute')
            }
            // if(regTest == 60){
            //     sch.timerSpan.html('hour')
            //     $(this).val('01')
            // }
            sch.membersCanAccessKino.html(regTest);
            $('#submit_schedule').attr('disabled', false)
        }).on('blur', function(e){
            if(e.currentTarget.value < 10 && e.currentTarget.value != ''){
                $(this).val('0'+ parseInt(e.currentTarget.value))
                // t.defaultStateMinutes = '0'+ parseInt(e.currentTarget.value)
                sch.membersCanAccessKino.html(e.currentTarget.value);
            }
            if(e.currentTarget.value == ''){
                $(this).val('00')
                // t.defaultStateMinutes = 0;
                sch.timerSpan.html('minutes')
                sch.membersCanAccessKino.html('00');
            }
        })

    };

    removeFromMembersList(email){
        this.selectedMembersEmails=this.selectedMembersEmails.filter(e=>e!=email);
        this.memberParticipantsContainer.find(`.user-container[email="${email}"]`).remove();
        $('#submit_schedule').attr('disabled', false)
        // this.hideMembersTimeContainer()
    }

    addToMembersList(email){
        // console.log("function addToMembersList");
        this.selectedMembersEmails.push(email);

        let selectedName=$("<div/>",{
            class:'user-detail',
            html:`<span class="email" data-email="${email}">${email}</span>`
        }),selectedRemove=$("<div/>",{
            class:'control',
            html:`<div class="remove-icon"><i class="fas fa-times" style="font-size:16px"></i></div>`
        }).on('click',(e)=>{
            e.stopPropagation();
            this.removeFromMembersList(email);
        });
        let selectedUser=$("<div/>",{
            class:'user-container',
            email:email,
            html:[selectedName,selectedRemove]
        });
        selectedUser.insertBefore(this.memberParticipantsContainer.find('.search-member-container'));
        this.memberParticipantsContainer.scrollTop(this.memberParticipantsContainer.height() * 100000000);
        $('#submit_schedule').attr('disabled', false)
     };

     init(){
        this.handleMembersInput();  
     }

    hideMembersTimeContainer(){
        // if(this.memberParticipantsContainer.find('.user-container').length <= 0){
        //     // this.membersTimeInputContainer.removeClass('show')
        //     this.membersTimeInput.prop({'disabled': true})
        // }
    }

    populateInputOneHourPrior(id){
        let currentTime = moment($('#schedule_start_time_input').val(), 'hh:mm A');
        let subtractedTime = moment(currentTime).subtract(60, 'minutes');
        // console.log(currentTime);
        // console.log(subtractedTime);
        // console.log(moment(currentTime).isAfter(subtractedTime))
        $(`#${id}_join_time`).html('');

        $(`#${id}_join_time_input`).val(currentTime.format('hh:mm A')).attr('joinbefore', 0)

        for(let i=0; i<=60; i++){
            // console.log(i)
            if(i==0 || i==15 || i==30 || i==45 || i==60){
                $(`#${id}_join_time`).append(`
                    <option value='${moment(subtractedTime).add(i, 'minutes').format('hh:mm A')}' ${i==30 && id=="moderator" ? 'selected' : i == 60 ? 'selected': ''}>${moment(subtractedTime).add(i, 'minutes').format('hh:mm A')}</option>
                `)
                if(i==30 && id=="moderator"){
                    $(`#${id}_join_time_input`).val(moment(subtractedTime).add(i, 'minutes').format('hh:mm A')).attr('joinbefore', i);
                }
            }
        }
    }
    differenceToTime(differenceInMinutes){
        let currentTime = moment($('#schedule_start_time_input').val(), 'hh:mm A');
        let subtractedTime = moment(currentTime).subtract(differenceInMinutes, 'minutes');
        return subtractedTime.format('hh:mm A');
    };


    updateOneHourPriorInputs(input){
        let sch = this;
        console.log(input)
        let time = moment($('#schedule_start_date').val() + " " + input.val(), 'YYYY-MM-DD hh:mm A')
        let currentTime = moment($('#schedule_start_date').val() + " " +$('#schedule_start_time_input').val(), 'YYYY-MM-DD hh:mm A');
        let subtractedTime = moment(currentTime).subtract(60, 'minutes');
        if(currentTime.diff(time, 'minutes') < 0){
            //means that time i later than start time of the event probably is a midnight event :/
            time = moment(subtractedTime.format('YYYY-MM-DD') + " " + input.val(), 'YYYY-MM-DD hh:mm A')
        }
        let outsideOneHourPrior = false;

        if(moment(time).isAfter(currentTime) || moment(time).isBefore(subtractedTime)){
            outsideOneHourPrior = true;
        }else {
            outsideOneHourPrior = false;
        }

        sch.checkIfTimeIsCorrect(input, outsideOneHourPrior);
        console.log(currentTime.diff(time, 'minutes'));

        input.attr('joinbefore', currentTime.diff(time, 'minutes'))
    }



    async onScheduleSuccess(res){
        console.log("Schedule success");
        let sch = this;
            this.listSchedules();
            this.selectedMembersEmails=[];
            this.memberParticipantsContainer.find('.user-container').remove();
            $('#email-schedule-btn').data('id', res.id)
            $('#email-schedule-btn').data('title', res.title)
            await axios.get(`/connect/outlook-google/calendar/${res.id}`).then( async result => {
                $('#add_to_gmail_group a').attr('href', result.data.google)
                $('#add_to_gmail_group a').attr('target', '_blank')

                $('#add_to_outlook_group a').attr('href', result.data.outlook)
                $('#add_to_outlook_group a').attr('target', '_blank')

                // loading schedule information
                // $('#schedule-info-modal-title').text(res.title)
                $('#schedule-info-body').html('')

                $('#schedule-info-body').append(`
                    <div class="item">
                        <div class="title">
                            <span>Title</span>
                        </div>
                        <div class="content">
                            <span>${res.title}</span>
                        </div>
                    </div>
                `);
                // how next event was before ${res.schedule_date}
                // if(res.recurring && (res.schedule_date != moment.utc(res.schedule_creation).format('dddd, MMMM DD'))) {
                   
                $('#schedule-info-body').append(`
                    <div class="item mt-1">
                        <div class="title">
                            <span>Created on</span>
                        </div>
                        <div class="content">
                            <span>${moment.utc(res.schedule_creation).format('dddd, MMMM Do, YYYY')}</span>
                        </div>
                    </div>
                `)
                $('#schedule-info-body').append(`
                    <div class="item mt-1">
                        <div class="title">
                            <span>Event date</span>
                        </div>
                        <div class="content">
                            <span>${moment.utc(res.next_event_date).format('dddd, MMMM Do, YYYY')} from ${res.start_time} to ${res.end_time}</span>
                        </div>
                    </div>
                `)
                // } else {
                //     $('#schedule-info-body').append(`
                //         <div class="item mt-1">
                //             <div class="title">
                //                 <span>Date created</span>
                //             </div>
                //             <div class="content">
                //                 <span>${res.schedule_date}</span>
                //             </div>
                //         </div>
                //     `)
                // }

                // let schedule_time = res.schedule_time.split(' - ')
                // let schedule_start_time = schedule_time[0]
                // let schedule_end_time = schedule_time[1]

                // $('#schedule-info-body').append(`
                //     <div class="item mt-1">
                //         <div class="title">
                //             <span>Start Time</span>
                //         </div>
                //         <div class="content">
                //         <span>${schedule_start_time}</span>
                //         </div>
                //     </div>
                // `)
                // $('#schedule-info-body').append(`
                //     <div class="item mt-1">
                //         <div class="title">
                //             <span>End Time</span>
                //         </div>
                //         <div class="content">
                //         <span>${schedule_end_time}</span>
                //         </div>
                //     </div>
                // `)
                $('#schedule-info-body').append(`
                    <div class="item mt-1">
                        <div class="title">
                            <span>Scheduled Kino Link</span>
                        </div>
                        <div class="content">
                        <a href="${res.location}">${res.location}</a>
                        </div>
                    </div>
                `)
                if(res.recurring) {
                    //fix recurring
                    $('#schedule-info-body').append(`
                        <div class="item mt-1">
                            <div class="title">
                                <span>Recurring</span>
                            </div>
                            <div class="content">
                            <span>${ res.recurring?.split('').map( (e, i) => i === 0 ? e.toUpperCase() : e ).join('')}</span>
                            </div>
                        </div>
                    `)
                }
                // EXPAND MODERATORS
                if(res.moderators && res.moderators.length) {
                    $('#schedule-info-body').append(`
                        <div class="item mt-1 item-expandable">
                            <div class="title cursor-pointer" id="scheduler-info-moderators-button">
                                ${sch.caretDownSvg}
                                <span>Moderators</span>
                            </div>
                            <div class="content scheduler-info-moderators-hidden">
                            <span>${ res.moderators.join(', ')}</span>
                            </div>
                        </div>
                    `)
                }
                $('#scheduler-info-moderators-button').on('click', function(){
                    if($('.scheduler-info-moderators-hidden').hasClass('expanded')){
                        $('.scheduler-info-moderators-hidden').removeClass('expanded')
                        $(this).html(`${sch.caretDownSvg} Moderators`)
                        $(this).removeClass('expanded')
                    }else{
                        $('.scheduler-info-moderators-hidden').addClass('expanded')
                        $(this).html(`${sch.caretUpSvg} Moderators`)
                        $(this).addClass('expanded')
                    }
                });

                // EXPAND MEMBERS
                if(res.members && res.members.length) {
                    $('#schedule-info-body').append(`
                        <div class="item mt-1 item-expandable">
                            <div class="title cursor-pointer" id="scheduler-info-members-button">
                                ${sch.caretDownSvg}
                                <span>Members</span>
                            </div>
                            <div class="content scheduler-info-members-hidden">
                            <span>${ res.members.join(', ')}</span>
                            </div>
                        </div>
                    `)
                }
                $('#scheduler-info-members-button').on('click', function(){
                    if($('.scheduler-info-members-hidden').hasClass('expanded')){
                        $('.scheduler-info-members-hidden').removeClass('expanded')
                        $(this).html(`${sch.caretDownSvg} Members`)
                        $(this).removeClass('expanded')
                    }else{
                        $('.scheduler-info-members-hidden').addClass('expanded')
                        $(this).html(`${sch.caretUpSvg} Members`)
                        $(this).addClass('expanded')
                    }
                });
                // EXPAND GUESTS
                if(res.guests && res.guests.length) {
                    $('#schedule-info-body').append(`
                        <div class="item mt-1 item-expandable">
                            <div class="title cursor-pointer" id="scheduler-info-guests-button">
                                ${sch.caretDownSvg}
                                <span>Guests</span>
                            </div>
                            <div class="content scheduler-info-guests-hidden">
                            <span>${ res.guests.join(', ')}</span>
                            </div>
                        </div>
                    `)
                }
                $('#scheduler-info-guests-button').on('click', function(){
                    if($('.scheduler-info-guests-hidden').hasClass('expanded')){
                        $('.scheduler-info-guests-hidden').removeClass('expanded')
                        $(this).removeClass('expanded')
                        $(this).html(`${sch.caretDownSvg} Guests`)
                        $(this).removeClass('expanded')
                    }else{
                        $('.scheduler-info-guests-hidden').addClass('expanded')
                        $(this).addClass('expanded')
                        $(this).html(`${sch.caretUpSvg} Guests`)
                        $(this).addClass('expanded')
                    }
                });

                let readMore = res.summary.length >= 200 ? true : false;
                $('#schedule-info-body').append(`
                    <div class="item mt-1">
                        <div class="title">
                            <span>Summary</span>
                        </div>
                        <div class="content">
                        <span class="m-0" id="summary-content">${(res.summary.trim().length) ? (readMore ? res.summary.substring(0, 200) + "..." : res.summary) : 'No description added'}</span>
                        <span class="show-more-summary">Show more</span>
                        </div>
                    </div>
                `)
                // SHOW MORE ON SUMMARY
                if (res.summary.length >= 200) {
                    $('.show-more-summary').show();
                }
                $('.show-more-summary').on('click', function() {
                    if(readMore){
                        readMore = false;
                        $('#summary-content').text(res.summary);
                    } else {
                        readMore = true;
                        $('#summary-content').text(`${res.summary.substring(0, 200)}...`);
                    }
                    $(this).text() === 'Show more' ? $(this).text('Show less') : $(this).text('Show more');
                });

                // $('#scheduleModal').modal('hide')
                setTimeout(() => {
                    $('#schedule-info-modal').modal()
                }, 300);
            })
        
    }
}
